<div class="l-header__inner is-active">
    <div class="l-header__logo">
        <a href="https://www.arima-onsen.com">
            <img
                src="https://www.arima-onsen.com/wp/wp-content/themes/arimaonsen/assets/images/logo.png"
                alt="有馬温泉"
            />
        </a>
    </div>
</div>
<div id="reserve-button" class="l-header__reserveWrap is-active">
    <div
        class="
            l-header__reserveButton l-header__reserveButton--red
        "
    >
        <a href="https://book.arima-onsen.com/" class="reserveLink">
            <div class="reserveButton">
                ご予約/ご購入
                <svg
                    width="161"
                    height="38"
                    viewBox="0 0 161 38"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="0" y="0" fill="none" width="161" height="38" />
                </svg>
            </div>
        </a>
    </div>
</div>
<div class="l-header__nav">
    <nav class="p-gNav">
        <div class="p-gNav__container">
            <div class="p-gNav__logo u-px20 u-md-block">
                <a href="https://www.arima-onsen.com">
                    <img
                        src="https://www.arima-onsen.com/wp/wp-content/themes/arimaonsen/assets/images/logo_white.png"
                        alt="有馬温泉"
                    />
                </a>
            </div>
            <div class="p-gNav__inner">
                <div class="p-gNav__listWrap">
                    <ul class="p-gNav__list">
                        <li class="p-gNav__item">
                            <a
                                href="https://www.arima-onsen.com/about"
                                class="
                                    p-gNav__link
                                    p-gNav__link--first
                                ">有馬温泉について<span class="linkArrow" /></a
                            >
                        </li>
                        <li class="p-gNav__item">
                            <a
                                href="https://www.arima-onsen.com/pickup"
                                class="p-gNav__link"
                                >見どころ情報<span class="linkArrow" /></a
                            >
                        </li>
                        <li class="p-gNav__item">
                            <a
                                href="https://www.arima-onsen.com/neighborhood"
                                class="p-gNav__link"
                                >周辺観光情報<span class="linkArrow" /></a
                            >
                        </li>
                        <li class="p-gNav__item">
                            <a
                                href="https://www.arima-onsen.com/access"
                                class="p-gNav__link"
                                >交通アクセス<span class="linkArrow" /></a
                            >
                        </li>
                        <li class="p-gNav__item">
                            <a
                                href="https://www.arima-onsen.com/info"
                                class="p-gNav__link"
                                >お知らせ<span class="linkArrow" /></a
                            >
                        </li>
                        <li class="p-gNav__item">
                            <a
                                href="https://www.arima-onsen.com/contact"
                                class="p-gNav__link"
                                >お問い合わせ<span class="linkArrow" /></a
                            >
                        </li>
                    </ul>
                    <ul class="p-gNav__subList u-mt8">
                        <li class="p-gNav__subItem">
                            <a
                                href="https://www.arima-onsen.com/question"
                                class="p-gNav__subLink">よくあるご質問</a
                            >
                        </li>
                        <li class="p-gNav__subItem">
                            <a
                                href="https://www.arima-onsen.com/privacypolicy"
                                class="p-gNav__subLink">プライバシーポリシー</a
                            >
                        </li>
                        <li class="p-gNav__subItem">
                            <a
                                href="https://www.arima-onsen.com/external_link"
                                class="p-gNav__subLink">外部リンク</a
                            >
                        </li>
                    </ul>
                </div>
                <div class="p-gNav__reserveWrap d-none">
                    <div class="p-gNav__reserveButton">
                        <a href="https://www.arima-onsen.com">有馬芸妓ご予約</a>
                    </div>
                    <div
                        class="
                            p-gNav__reserveButton
                            p-gNav__reserveButton--red
                        "
                    >
                        <a href="https://www.arima-onsen.com">ご予約/ご購入</a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <div class="l-header__buttonWrap">
        <div id="nav-button" class="l-header__button is-active">
            <div class="buttonWrap">
                <span />
                <span />
                <span />
            </div>
        </div>
    </div>
</div>
